var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.remain)?_c('div',{ref:"elem",staticClass:"timer"},[_vm._v(" "+_vm._s(_vm.remain)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }